// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1HpBQ","inner":"Footer_inner__3c50Q"};